import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import AboutHeroSection from './sections/AboutHeroSection';
import AboutMissionSection from './sections/AboutMissionSection';
import AboutValuesSection from './sections/AboutValuesSection';
import AboutStorySection from './sections/AboutStorySection';
import AboutBeliefsSection from './sections/AboutBeliefsSection';

import AboutCoreValuesSection from './sections/AboutCoreValuesSection';
import PastorsSection from '../../sections/PastorsSection/PastorsSection';
import AboutJoinSection from './sections/AboutJoinSection';
import './AboutPage.scss';

const AboutPage = () => {
    const { t } = useTranslation();

    return (
        <div className="about-page">
            <Helmet>
                <title>{t('seo_about_title')}</title>
                <meta name="description" content={t('seo_about_description')} />
                <meta property="og:title" content={t('seo_about_title')} />
                <meta property="og:description" content={t('seo_about_description')} />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header transparent />
            <AboutHeroSection />
            <AboutMissionSection />
            <AboutValuesSection />
            <AboutStorySection />
            <AboutBeliefsSection />

            <AboutCoreValuesSection />
            <PastorsSection />
            <AboutJoinSection />
            <Footer />
        </div>
    );
};

export default AboutPage;
